
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.39 3.703v.813H2.235l-.007.093a3.23 3.23 0 00.015.532 3.115 3.115 0 00.258 1c.063.135.133.257.21.367a2.028 2.028 0 00.556.531 2.9 2.9 0 00.336.172c.125.047.255.083.39.11.136.02.276.03.422.03.406 0 .768-.028 1.086-.085a6.884 6.884 0 001.102-.313l.203.625A7.058 7.058 0 015.46 8a7.057 7.057 0 01-1.367.125c-.672 0-1.255-.14-1.75-.422-.49-.281-.867-.7-1.133-1.258C.95 5.883.82 5.203.82 4.406c0-.76.15-1.448.452-2.062.308-.62.75-1.1 1.329-1.438C3.18.568 3.857.398 4.632.398c.397 0 .761.03 1.095.086a5.94 5.94 0 011.085.29l-.21.632a7.654 7.654 0 00-.891-.187 5.69 5.69 0 00-.805-.055 2.77 2.77 0 00-1.242.281c-.38.183-.698.466-.953.852-.25.385-.401.854-.453 1.406H6.39z","fill":"currentColor"}})])
          )
        }
      }
    